import type { ConfigSection, GameProfile, ProfileCtx } from "./types";

const configSections: ConfigSection[] = [{ component: "ConfSection", props: { name: "basic" } }];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  configSections,
});
